/**
 * Creates a validation object
 */
export const ValidationData = {
  message: String,
  valid: String,
};

export function createValidationDataObject(valid = true, message = undefined) {
  return {
    valid,
    message,
  };
}
